import { useState, useEffect } from 'react';
import { getPantoneColorList, deletePantoneColor } from 'helpers/backend_helper';
import { Common } from 'helpers/common';
import filterDataBySearch from 'Common/filterDataBySearch';

export const usePantoneColorList = () => {
    const [allPantoneColors, setAllPantoneColors] = useState<any[]>([]);
    const [pantoneColorList, setPantoneColorList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const uiHelper = new Common();

    useEffect(() => {
        loadPantoneColors(false);
    }, []);

    const loadPantoneColors = async (reload: boolean) => {
        try {
            if (pantoneColorList.length === 0 || reload) {
                const response = await getPantoneColorList();
                if (response) {
                    setPantoneColorList((response.data || response) as never[]);
                    setAllPantoneColors((response.data || response) as never[]);
                }
            }
        } catch (error) {
            console.error('Error loading pantone colors:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (pantoneColorId: number) => {
        try {
            await deletePantoneColor(pantoneColorId);
            setPantoneColorList((prevList) => prevList.filter((pantoneColor: any) => pantoneColor.id !== pantoneColorId));
            uiHelper.showSuccessMessage("Pantone Color has been deleted successfully.");
            return true;
        } catch (error) {
            console.error('Error deleting pantone color:', error);
            return false;
        }
    };

    const updatePantoneColorList = (result: any, isEdit: boolean, pantoneColorData: any) => {
        if (isEdit && pantoneColorData?.id) {
            setPantoneColorList((prevList) =>
                prevList.map((pantoneColor: any) => (pantoneColor.id === pantoneColorData.id ? { ...pantoneColor, ...result.data || result } : pantoneColor))
            );
        } else {
            setPantoneColorList((prevList) => [...prevList, result.data || result]);
        }
    };

    const filterSearchData = (searchText: string) => {
        if (searchText) {
            filterDataBySearch(allPantoneColors, searchText, ['code', 'name', 'hex_colour'], setPantoneColorList);
        } else {
            setPantoneColorList(allPantoneColors);
        }
    };

    return {
        pantoneColorList,
        isLoading,
        handleDelete,
        updatePantoneColorList,
        filterSearchData,
    };
};